export const roundOff = (num, nearest) => {
  const roundedValue = Math.round(num / nearest) * nearest;
  return Number(roundedValue.toFixed(2)); // Adjust the number of decimal places as needed (e.g., 2 decimal places)
};
